module.exports = __webpack_public_path__ + "static/media/incident-management.2b78d281.svg";